import { render, staticRenderFns } from "./Configurator.vue?vue&type=template&id=87c10a38&scoped=true"
import script from "./Configurator.vue?vue&type=script&lang=ts"
export * from "./Configurator.vue?vue&type=script&lang=ts"
import style0 from "./Configurator.vue?vue&type=style&index=0&id=87c10a38&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c10a38",
  null
  
)

export default component.exports